import { Component, Input } from '@angular/core';
import { valueAccessorProvider } from '../../utils/provider-builders';
import { CreativeAssetService } from '../../woo_services.module/CreativeAssetService';
import { TranslationService } from '../../woo_services.module/TranslationService';
import { JPGValidatorService } from '../../woo_services.module/asset_validator/JPGValidatorService';
import { CreativeAssetType, wooId } from '../../woo_services.module/shared-types';
import { AssetUpload } from './asset-upload.component';

@Component({
  selector: 'image-upload',
  templateUrl: './asset-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  providers: [valueAccessorProvider(ImageUpload)],
  standalone: false,
})
export class ImageUpload extends AssetUpload {
  @Input() customerId: wooId;

  assetType = CreativeAssetType.Image;
  acceptedFileType = 'image/jpeg';

  constructor(
    protected creativeAssetService: CreativeAssetService,
    protected translationService: TranslationService,
    protected validationService: JPGValidatorService,
  ) {
    super(creativeAssetService, translationService, validationService, null);
  }
}
